import header1 from './1.jpg';
import header2 from './2.jpg';
import header3 from './3.jpg';
import header4 from './4.jpg';
import header5 from './5.jpg';
import header6 from './6.jpg';
import header7 from './7.jpg';
import header8 from './8.jpg';
export const headerImages  = [header8,header5,header6];
// export const headerImages  = [header7];